/**
 * Display state of a version 2 scorecard, evaluated by the API in priority order.
 *
 * The specification lists the members but not their values. It states the field follows
 * the Lotto V2 pattern and its example pairs `Favourite: true` with `State: 1`, so the
 * values match the ones the Lotto V2 endpoint sends.
 */
export enum SCORECARD_STATE {
  None = 0,
  /** The scorecard is favourited */
  Favourite = 1,
  /** The start date is in the future */
  ComingSoon = 2,
  /** The scorecard is locked */
  ViewableOnly = 3,
  /** The scorecard has 1 action left */
  LimitedStock = 5,
  /** The scorecard started within the last 7 days */
  NewItem = 9,
  /** The scorecard will end within the next 7 days */
  EndingSoon = 10,
}
